import { render, staticRenderFns } from "./PublishableEntityForm.vue?vue&type=template&id=487e9bde&"
import script from "./PublishableEntityForm.vue?vue&type=script&lang=js&"
export * from "./PublishableEntityForm.vue?vue&type=script&lang=js&"
import style0 from "./PublishableEntityForm.vue?vue&type=style&index=0&id=487e9bde&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports